<template>
	<div v-if="visible" class="popup">
		<div class="bg"></div>
		<div class="popupInner">
			<div class="title">
				<div>{{$t('components.addressPopup.title')}}</div>
				<img src="../assets/images/close.png" class="closeIcon" @click="closePopup" />
			</div>
			<div class="ul">
				<div class="flexArea">
					<div class="li halfWidth">
						<label><span>*</span>{{$t('components.addressPopup.labelName')}}</label>
						<div>
							<input type="text" :placeholder="$t('components.addressPopup.placeholderName')" required  v-model="form.receiveman"/>
							<span class="warningText"></span>
						</div>
					</div>
					<div class="li halfWidth">
						<label><span>*</span>{{$t('components.addressPopup.labelPhone')}}</label>
						<div>
							<input type="text" :placeholder="$t('components.addressPopup.placeholderPhone')" required v-model="form.mobile" />
							<span class="warningText"></span>
						</div>
					</div>
				</div>

				<div class="li">
					<label><span>*</span>{{$t('components.addressPopup.labelAddress')}}</label>
					<div class="selects">
						<select class="countryArea " v-model="selectedCountry" @change="updateProvinces" required>
							<option v-for="(country,index) in countries" :key="country.id" :value="country">
								{{ country.name }}</option>
						</select>
						<select class="provincesArea " v-model="selectedProvince" @change="updateCities" required>
							<option :value="defaultselect" disabled>{{$t('components.addressPopup.selectProvince')}}</option>
							<option v-for="(province,index) in provinces" :key="province.id" :value="province">
								{{ province.name }}</option>
						</select>
						<select class="cityArea" v-model="selectedCity" @change="updateAreas" v-if="cities"
							required>
							<option :value="defaultselect" disabled>{{$t('components.addressPopup.selectCity')}}</option>
							<option v-for="(city,index) in cities" :key="city.id" :value="city">{{ city.name }}
							</option>
						</select>
						<select class="areaArea" v-model="selectedArea" v-if="areas" required>
							<option :value=defaultselect disabled>{{$t('components.addressPopup.selectArea')}}</option>
							<option v-for="(area,index) in areas" :key="area.id" :value="area">{{ area.name }}
							</option>
						</select>
					</div>
				</div>
				<div class="li">
					<label><span>*</span>{{$t('components.addressPopup.labelDetailAddress')}}</label>
					<div class="selects">
						<textarea class="textArea" :placeholder="$t('components.addressPopup.placeholderDetailAddress')" v-model="form.address"></textarea>
					</div>
				</div>
				<div class="li">
					<label>{{$t('components.addressPopup.labelZipcode')}}</label>
					<div>
						<input type="text" :placeholder="$t('components.addressPopup.placeholderZipcode')" class="smallSize" required v-model="form.zipcode" />
					</div>
				</div>
				<div class="li">
					<label>{{$t('components.addressPopup.labelIsDefault')}}</label>
					<div class="checkboxArea">
						<input type="checkbox" required  v-model="form.isdefault"/>
						<span>{{$t('components.addressPopup.textDefaultAddress')}}</span>
					</div>
				</div>
			</div>
				<div class="btns">
					<div class="btnStyle saveBtn" @click="closePopupAdd">{{$t('components.addressPopup.btnSave')}}</div>
					<div class="btnStyle cancelBtn" @click="closePopup">{{$t('components.addressPopup.btnCancel')}}</div>
				</div>
		</div>
	</div>
</template>

<script>
	import { Form } from 'element-ui';
import imgSwiper from './imgSwiper.vue';
	export default {
		components: {
			imgSwiper
		},
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			selectId:
			{
				type: Number,
				default:0
			}
		},
		data() {
			return {
				invoice: 0,
				defaultselect:{"id":0,"level":0,"name":"","parent_id":0,"gmt_create":"","gmt_modified":"","is_show":0},
				selectedCountry: {},
				selectedProvince: {"id":0,"level":0,"name":"","parent_id":0,"gmt_create":"","gmt_modified":"","is_show":0},
				selectedCity: {"id":0,"level":0,"name":"","parent_id":0,"gmt_create":"","gmt_modified":"","is_show":0},
				selectedArea: {"id":0,"level":0,"name":"","parent_id":0,"gmt_create":"","gmt_modified":"","is_show":0},
				countries: [],
				provinces: [],
				cities: [],
				areas: [],
				form:{
					receiveman:'',
					mobile:'',
					zipcode:'',
					address:'',
					isdefault:0,
				},				
			}
		},
		created()
		{

		},
		mounted() {
			this.getCountries();
		},
		watch: {
			selectId() { // 监听select
				if (this.selectId>0) {
					this.$scUtil.axiosPost(this, 'ReceiveApi/GetReceiveInfo', {
						id: this.selectId
					}, res => {
						console.log(res.code);
						if (res.code == 100) {
							console.log(res.data);
							this.form.receiveman=res.data[0].receive_man;
							this.form.mobile=res.data[0].receive_mobile;
							this.form.zipcode=res.data[0].receive_zipcode;
							this.form.address=res.data[0].receive_address;
							this.form.isdefault=res.data[0].is_default;
							this.selectedCountry=this.countries.find(p=>p.id==res.data[0].receive_countryid);
							this.selectedProvince=this.provinces.find(p=>p.id==res.data[0].receive_provinceid);
							this.cities = this.getCitiesByProvinceAsync(res.data[0].receive_provinceid,res.data[0].receive_cityid);
							this.areas = this.getAreasByCityAsync(res.data[0].receive_cityid,res.data[0].receive_areaid);
							
						}
					
					});		
				}
			}
		},
		methods: {
			closePopupAdd() {	
				let that=this;
				this.$scUtil.axiosPut(this, 'ReceiveApi/Add', {
					id:this.selectId,
				receive_man:this.form.receiveman,
				receive_mobile:this.form.mobile,
				receive_zipcode:this.form.zipcode,
				receive_address:this.form.address,
				receive_countryid:this.selectedCountry.id,
				receive_provinceid:this.selectedProvince.id,
				receive_cityid:this.selectedCity.id,
				receive_areaid:this.selectedArea.id,
				is_default:((this.form.isdefault)?1:0),
				userName: localStorage.getItem('username'),
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: res.message,
							type: "success"
						});
						that.$emit('close');
						//this.selectedCountry={};
						this.selectedProvince={};
						this.selectedCity={};
						this.selectedArea={};
						this.form={
							receiveman:'',
							mobile:'',
							zipcode:'',
							address:'',
							isdefault:0,
						};

					}
					else
					{
						this.$message({
							message: res.message,
							type: "warning"
						});
					}
				});				
			},
			closePopup()
			{
				//this.selectedCountry={};
				this.selectedProvince=this.defaultselect;
				this.selectedCity=this.defaultselect;
				this.selectedArea=this.defaultselect;
				this.form={
					receiveman:'',
					mobile:'',
					zipcode:'',
					address:'',
					isdefault:0,
				};
				this.$emit('close');	
			},
			invoiceClick(idx) {
				this.invoice = idx;
			},
			updateProvinces() {
				this.selectedCity = this.defaultselect;
				this.selectedArea = this.defaultselect;
				this.selectedProvince = this.defaultselect;
				this.provinces = this.getProvincesByCountry(this.selectedCountry);
			},
			updateCities() {
				this.selectedCity = this.defaultselect;
				this.selectedArea = this.defaultselect;
				this.cities = this.getCitiesByProvince(this.selectedProvince);
			},
			updateAreas() {
				this.selectedArea = this.defaultselect;
				this.areas = this.getAreasByCity(this.selectedCity);
			},
			getCountries() {

				this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByLevel', {
					level: 1
				}, res => {
					if (res.code == 100) {
						this.countries = res.data;
						this.selectedCountry = this.countries[0];
						this.getProvincesByCountry(this.selectedCountry);
						//console.log(JSON.stringify(this.selectedCountry));
					}

				});

			},
			getProvincesByCountry(country) {
				this.selectedCountry = country;
				// 这里应根据实际数据结构获取省份列表
				this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
					parentId: country.id
				}, res => {
					if (res.code == 100) {
						this.provinces = res.data;
						
						//console.log(this.advertList);
					}

				});
			},
			getCitiesByProvince(province) {
				//console.log(JSON.stringify(province));
				this.selectedProvince = province;
				// 这里应根据实际数据结构获取城市列表
				this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
					parentId: province.id
				}, res => {
					if (res.code == 100) {
						this.cities = res.data;
						//console.log(this.cities);
					}

				});
			},
			getAreasByCity(city) {
				this.selectedCity = city;
				// 这里应根据实际数据结构获取区域列表
				this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
					parentId: city.id
				}, res => {
					if (res.code == 100) {
						this.areas = res.data;
						//console.log(this.advertList);
					}

				});
			},getCitiesByProvinceAsync(pid,cid) {
				// 这里应根据实际数据结构获取城市列表
				this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
					parentId: pid
				}, res => {
					if (res.code == 100) {
						this.cities = res.data;
						this.selectedCity=this.cities.find(p=>p.id==cid);
						//console.log(this.cities);
					}

				});
			},
			getAreasByCityAsync(cid,aid) {
				// 这里应根据实际数据结构获取区域列表
				this.$scUtil.axiosPost(this, 'LocationApi/GetLocationListByParentId', {
					parentId: cid
				}, res => {
					if (res.code == 100) {
						this.areas = res.data;
						this.selectedArea=this.areas.find(p=>p.id==aid);
					}

				});
			},
		}
	}
</script>

<style scoped>
	.bg {
		background-color: rgba(0, 0, 0, 0.4);
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
	}

	.popup {
		width: 100vw;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
	}

	.popupInner {
		background: #fff;
		width: 860px;
		border-radius: 15px;
		z-index: 999;
	}

	.title {
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		color: #222;
		padding: 0 15px;
	}

	.ul {
		padding: 20px 30px 0 30px;
		box-sizing: border-box;
	}

	.ul .li {
		min-height: 65px;
		display: flex;
		align-items: baseline;
		font-size: 13px;
		color: #333;
	}

	.ul .li label {
		white-space: nowrap;
		width: 120px;
		min-width: 120px;
		text-align: right;
		margin-right: 10px;
	}

	.ul .li span {
		color: #f74848;
	}

	.ul .li input[type='text'] {
		width: 450px;
		height: 36px;
		border: 1px solid #d9d9d9;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.ul .li input.red {
		border: 1px solid #f74848;
	}

	.warningText {
		font-size: 12px;
	}

	.btns {
		cursor: pointer;
		display: flex;
		padding-right: 50px;
		margin-bottom: 20px;
		justify-content: flex-end;
	}

	.btnStyle {
		width: 91px;
		height: 44px;
		font-size: 12px;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.saveBtn {
		border: 1px solid #0380fe;
		background: #0380fe;
		color: #fff;
		margin-right: 20px;
	}

	.cancelBtn {
		border: 1px solid #d9d9d9;
		background: #fff;
		color: #333;
	}


	.tabBtns {
		display: flex;
		align-items: center;
	}

	.tabBtn {
		height: 30px;
		line-height: 30px;
		padding: 0 17px;
		font-size: 14px;
		color: #333333;
		border: 1px solid #cccccc;
		border-radius: 5px;
		position: relative;
		margin-right: 18px;
	}

	.tabBtn.active {
		border: 1px solid #0380fe;
	}

	.tabBtn img {
		position: absolute;
		bottom: 0px;
		right: 0px;
	}

	.invoiceBtn {
		display: flex;
		align-items: center;
	}


	.invoiceBtn .orange {
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #ff8d50;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}

	.invoiceBtn .blue {
		width: 22px;
		height: 22px;
		color: #fff;
		background-color: #0380fe;
		border-radius: 5px;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 9px;
	}

	.countryArea {
		width: 140px;
		height: 38px;
		margin-right: 10px;
	}

	.provincesArea {
		width: 140px;
		height: 38px;
		margin-right: 10px;
	}

	.cityArea {
		width: 140px;
		height: 38px;
		margin-right: 10px;
	}

	.areaArea {
		width: 140px;
		height: 38px;
	}

	.selects {
		display: flex;
		align-items: center;
	}

	select {
		border: 1px solid #d9d9d9;
	}

	.textArea {
		height: 56px;
		resize: vertical;
		width: 530px;
		padding: 10px;
		box-sizing: border-box;
		border: 1px solid #d9d9d9;
	}

	.ul .li input.smallSize {
		width: 200px;
	}

	.checkboxArea {
		display: flex;
		align-items: center;
	}

	.ul .li .checkboxArea span {
		font-size: 12px;
		margin-left: 10px;
		color: #333;
	}

	.ul .li.halfWidth input[type='text'] {
		width: 200px;

	}

	.flexArea {
		display: flex;
		align-items: center;
	}

	select:invalid {
		color: #999;
	}
</style>